import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimTypeAutomationRule.Delete.IRequest;
type Response = Api.Core.ClaimTypeAutomationRule.Delete.IResponse;
type Headers = Api.Core.ClaimTypeAutomationRule.Delete.IHeaders;
const url = '/api/Claims/ClaimTypeAutomationRule/:id';
export default async function claimTypeAutomationRuleDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
